// @flow

import { type PaymentMethodCode, type PaymentMethod } from './types';

export function getCode(paymentMethod: PaymentMethod): PaymentMethodCode {
  return paymentMethod.code;
}
